import { Data } from '../signup-data/DATA';
import { DataOptions } from '../signup-data/signupDataOptions';
import { useSignupData } from '../signup-data/useSignupData';
import { useRecommendedHublet } from './useRecommendedHublet';
export const useHublets = () => {
  const {
    recommendedHublet
  } = useRecommendedHublet();
  const {
    data
  } = useSignupData(Data.HubletSelection);
  const hubletOptions = DataOptions[Data.HubletSelection].sort(hubletOption => hubletOption === recommendedHublet ? -1 : 0);
  const isUsingHubletRecommendation = data === recommendedHublet;
  return {
    isUsingHubletRecommendation,
    hubletOptions
  };
};